import React from 'react'
import OEEGrid from '../features/oeegrid'
export default function OeeGrid() {
  return (
    <OEEGrid />
  )
}
